<script setup lang="ts">
import type { DisciplineScheduleTutorRow } from '../model/modal-discipline-schedule-assign.hook'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { BtnRadio } from '@shared/ui/buttons'

import DisciplineScheduleAvailability from './DisciplineScheduleAvailability.vue'

defineOptions({
  name: 'DisciplineScheduleTutors',
})

defineProps<{
  rows: DisciplineScheduleTutorRow[]
  isChosen: (row: DisciplineScheduleTutorRow) => boolean
}>()

const emit = defineEmits<{
  'click:choose': [row: DisciplineScheduleTutorRow]
}>()

const COLUMNS = ['', 'Tutor', 'Schedule', 'Availability']
</script>

<template>
  <div class="discipline-schedule-tutors">
    <AppTable
      v-if="rows.length"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh
            v-for="column in COLUMNS"
            :key="column"
            :class="{ 'discipline-schedule-tutors__radio': !column }"
          >
            {{ column }}
          </AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="row in rows"
          :key="row.key"
        >
          <AppTd class="discipline-schedule-tutors__radio">
            <BtnRadio
              text=""
              :label="`Choose ${row.tutorName}`"
              :checked="isChosen(row)"
              @click="emit('click:choose', row)"
            />
          </AppTd>
          <AppTd>
            <div class="discipline-schedule-tutors__tutor">
              <LinkTextPrimaryMedium
                v-if="row.tutorUrl"
                :href="row.tutorUrl"
              >
                {{ row.tutorName }}
              </LinkTextPrimaryMedium>
              <AppText
                name="body2"
                color="slate-500"
              >
                {{ row.paidLabel }}
              </AppText>
            </div>
          </AppTd>
          <AppTd>
            <div class="discipline-schedule-tutors__slots">
              <AppText
                v-for="slot in row.slots"
                :key="slot"
                name="body2"
              >
                {{ slot }}
              </AppText>
            </div>
          </AppTd>
          <AppTd>
            <DisciplineScheduleAvailability
              :status="row.status"
              :label="row.label"
              :tooltip="row.tooltip"
            />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
    <AppText
      v-else
      name="body1"
    >
      You don't have any available tutor slots for this time
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleTutors.scss" />
